import {
  EndpointMetaDataType,
  EndpointsSearchRequest,
  EndpointsSearchResponse,
} from 'interfaces'
import {AxiosResponse} from 'axios'
import {unwrapAPIError} from 'utils'
import {getEndpointBaseUrl, getFlightdeckBaseUrl, requestHandler} from '../HTTP'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'

const endpointBaseUrl = getEndpointBaseUrl()
const flightdeckBaseUrl = getFlightdeckBaseUrl()

const getEndpointMetaData = async (): Promise<
  AxiosResponse<EndpointMetaDataType>
> => {
  try {
    return await requestHandler({
      method: HttpMethods.GET,
      url: `${endpointBaseUrl}${EndPoints.GetEndpointMetadata}?aggregation=endpoint_details`,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const getEndpointsSearch = async (
  params: EndpointsSearchRequest,
): Promise<AxiosResponse<EndpointsSearchResponse>> => {
  try {
    return await requestHandler<EndpointsSearchResponse>({
      method: HttpMethods.GET,
      // Override axios baseUrl
      url: `${flightdeckBaseUrl}${EndPoints.EndpointsSearch}`,
      options: {
        params,
      },
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const EndpointsService = {
  getEndpointMetaData,
  getEndpointsSearch,
}
